import axios from "@/api/axios";

const API_URL = process.env.VUE_APP_API_HOST;

/**
 * @param {Object} params
 * @param {number[]} params.corporateGroupIds
 * @param {number} params.page
 * @param {number} params.perPage
 * @param {string} params.searchQuery
 * @param {AbortSignal} params.signal
 */
export async function getBusinessTypesApi({
  corporateGroupIds,
  page = 1,
  perPage = 15,
  searchQuery = "",
  signal = null,
}) {
  const response = await axios.get(`${API_URL}/api/admin/business-types`, {
    params: {
      "corporate-group-ids": corporateGroupIds,
      "page[number]": page,
      "page[size]": perPage,
      search: searchQuery,
    },
    signal,
  });
  return response.data;
}
